import { useState, useEffect } from "react";

/**
 * Custom hook for managing appointment data and related operations
 * Handles appointment filtering by date range and status management
 */
export const useAppointmentData = (consultable, fromDate, toDate) => {
  const [appointmentsData, setAppointmentsData] = useState([]);

  // Filter appointments by date range
  const filterAppointmentsByDateRange = (appointments, fromDate, toDate) => {
    return appointments.filter(appointment => {
      const appointmentDate = new Date(appointment.created_date);
      const startDate = new Date(fromDate);
      const endDate = new Date(toDate);
      return appointmentDate >= startDate && appointmentDate <= endDate;
    });
  };

  useEffect(() => {
    // Load and filter appointments for appointment tab only (not consultation tab)
    if (!consultable) {
      const storedAppointments = localStorage.getItem("appointments");
      if (storedAppointments) {
        const parsedAppointments = JSON.parse(storedAppointments);
        const filteredAppointments = filterAppointmentsByDateRange(parsedAppointments, fromDate, toDate);
        setAppointmentsData(filteredAppointments);
      } else {
        setAppointmentsData([]);
      }
    }
  }, [consultable, fromDate, toDate]);

  return {
    appointmentsData,
    setAppointmentsData,
    filterAppointmentsByDateRange
  };
};